import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConflictError, AppErrors, NotFoundError, BadRequestError } from '@fitness-force/errors';
import { CreateResponse, SaleReturnCalculationRequest } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesReturnService {
  constructor(private http: HttpClient, private router: Router) { }
  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  SalesReturnCalculation(tenantId: number, client_id:number, invoiceId: number,data:SaleReturnCalculationRequest):Observable<any> {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/clients/${client_id}/invoices/${invoiceId}/salesreturn_excessamount_calculation`, data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateSalesReturn(tenantId: number, client_id:number, invoiceId: number,data:SaleReturnCalculationRequest):Observable<CreateResponse> {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/clients/${client_id}/invoices/${invoiceId}/sales_return`, data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  VoidSalesReturn(tenantId: number, client_id:number, salesReturnId: number,data:any):Observable<any> {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/clients/${client_id}/salesreturn/${salesReturnId}/void`, data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
  SendSalesReturnPdf(client_id:number, invoiceId:number, salesReturnId: number, channels:any[]):Observable<any> {
    return this.http.post(`${environment.BASE_URL}/clients/${client_id}/invoices/${invoiceId}/sales_return/${salesReturnId}/pdf_salesreturn_invoice`,channels,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetSalesReturnPrint(client_id:number, invoiceId:number, salesReturnId: number):Observable<any> {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'text/plain',
    //   })
    // };
    const url= `${environment.BASE_URL}/clients/${client_id}/invoices/${invoiceId}/sales_return/${salesReturnId}/pdf_salesreturn_invoice`;
    return this.http.get(url)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getOpenSalesReturnPDF(uuid:string): Observable<string> {
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'text/plain',
    //   })
    // };
    const url= `${environment.BASE_URL}/open/sales_return/${uuid}/pdf_sales_return`;
    return this.http.get(url, { responseType: 'text',headers: this.httpOptions.headers}).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetAvailableOnlineRefund(tenantId:number, clientId:number, invoiceId: number):Observable<any> {
    const url= `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/AvailableOnlineRefund/${invoiceId}`;
    return this.http.get(url,{headers: this.httpOptions.headers})
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



}
